import React, { useState, useEffect, useCallback  } from "react";
import { listFiles, deleteFile, uploadFile, runCode, renameFile, fetchChannels, fetchCSV, getChannelName,trainModel,downloadModel,listModels,deleteModel} from "./api/api";
import { toast } from "react-toastify";
import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";
// import axios from "axios";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
    Box,
    Button,
    Typography,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FolderIcon from "@mui/icons-material/Folder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const CodePlayground = ({ token }) => {
    //const [code, setCode] = useState("");
    const [code, setCode] = useState("");
    const [codeLoaded, setCodeLoaded] = useState(false);
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");

    if (storedUserId) {
        setUserId(storedUserId);

        const savedCode = localStorage.getItem(
            `codePlaygroundCode_${storedUserId}`
        );

        if (savedCode !== null) {
            setCode(savedCode);
        }
    }

    setCodeLoaded(true);
}, []);

// SAVE CODE WHENEVER YOU TYPE
useEffect(() => {
    if (!codeLoaded) return;

    const storedUserId = localStorage.getItem("userId");

    if (storedUserId) {
        localStorage.setItem(
            `codePlaygroundCode_${storedUserId}`,
            code
        );
    }
}, [code, codeLoaded]);
// useEffect(() => {
//     const storedUserId = localStorage.getItem("userId");

//     if (storedUserId) {
//         const savedCode = localStorage.getItem(
//             `codePlaygroundCode_${storedUserId}`
//         );

//         setCode(savedCode || "");
//     }
// }, []);
    const [output, setOutput] = useState("");
    const [plots, setPlots] = useState([]); // FIXED: Initialize as an empty array
    const [terminalHeight, setTerminalHeight] = useState(40);
    const [plotPopupOpen, setPlotPopupOpen] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [file, setFile] = useState(null);
    const [renameDialogOpen, setRenameDialogOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [newFileName, setNewFileName] = useState("");
    const [isRunning, setIsRunning] = useState(false);
    const [isTraining, setIsTraining] = useState(false);
    const [trainedModels, setTrainedModels] = useState([]);
    const [modelName, setModelName] = useState("");
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState("");
    const [userId, setUserId] = useState("");
    const [channelName, setChannelName] = useState("");
    // const BACKEND_URL = "http://cloud.xtranssolutions.com/node";
    // const API_BASE_URL = "http://cloud.xtranssolutions.com/tem";
    
    const fetchFiles = useCallback(async () => {
        try {
            const response = await listFiles(token);
            setFiles(response.data.files || []);
            console.log("Fetched files:", response.data.files);
            console.log(response.data.files);
        } catch (error) {
            toast.error("Failed to fetch files.");
        }
    }, [token]);
    const fetchModels = useCallback(async () => {
    try {
        const response = await listModels(token);

        setTrainedModels(
            response.data.models || []
        );

        console.log(
            "Fetched trained models:",
            response.data.models
        );

    } catch (error) {

        console.error(
            "Failed to fetch trained models:",
            error
        );

        toast.error("Failed to fetch trained models.");
    }
}, [token]);

    useEffect(() => {
        fetchFiles();
    }, [fetchFiles]);
    useEffect(() => {
    fetchModels();
}, [fetchModels]);
//      useEffect(() => {
//     const storedUserId = localStorage.getItem("userId");
//     if (storedUserId) {
//         setUserId(storedUserId);
//     }
// }, []);
// useEffect(() => {
//     const storedUserId = localStorage.getItem("userId");

//     if (storedUserId) {
//         localStorage.setItem(
//             `codePlaygroundCode_${storedUserId}`,
//             code
//         );
//     }
// }, [code]);
    const handleRunCode = async () => {
        setIsRunning(true);
        try {
            const response = await runCode(code, token);
            setOutput(response.data.output);
            setPlots(response.data.plots || []);

            toast.success("Code executed successfully!");

            if (response.data.plots && response.data.plots.length > 0) {
                setPlotPopupOpen(true);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Unknown error occurred.";
            setOutput(`Error: ${errorMessage}`);
            toast.error("Error executing code");
        } finally {
            setIsRunning(false);
        }
    };
//     const handleTrainModel = async () => {

//     if (!code.trim()) {
//         toast.warn("Please enter training code.");
//         return;
//     }

//     setIsTraining(true);
//     setTrainedModel(null);

//     try {

//         const response = await trainModel(code, token);

//         if (response.data.success) {

//             setTrainedModel(response.data.filename);

//             // Show training output
//             if (response.data.output) {
//                 setOutput(response.data.output);
//             }

//             toast.success("Model trained successfully!");

//         } else {

//             toast.error(
//                 response.data.error || "Model training failed."
//             );
//         }

//     } catch (error) {

//         const errorMessage =
//             error?.response?.data?.error ||
//             "Model training failed.";

//         setOutput(`Training Error:\n${errorMessage}`);

//         toast.error("Model training failed.");

//     } finally {

//         setIsTraining(false);
//     }
// };
const handleTrainModel = async () => {

    // Check code
    if (!code.trim()) {
        toast.warn("Please enter training code.");
        return;
    }

    // Check model name
    if (!modelName.trim()) {
        toast.warn("Please enter a model name.");
        return;
    }

    setIsTraining(true);

    try {

        // Send code + model name
        const response = await trainModel(
            code,
            token,
            modelName
        );

        if (response.data.success) {

            // Show training output
            if (response.data.output) {
                setOutput(response.data.output);
            }

            toast.success(
                `${response.data.model_name || modelName} trained successfully!`
            );

            // Refresh model list
            fetchModels();

        } else {

            toast.error(
                response.data.error ||
                "Model training failed."
            );
        }

    } catch (error) {

        const errorMessage =
            error?.response?.data?.error ||
            "Model training failed.";

        setOutput(
            `Training Error:\n${errorMessage}`
        );

        toast.error("Model training failed.");

    } finally {

        setIsTraining(false);
    }
};

const handleDownloadModel = async (filename) => {

    try {

        const response = await downloadModel(
            filename,
            token
        );

        const blob = new Blob(
            [response.data],
            {
                type: "application/octet-stream"
            }
        );

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");

        link.href = url;
        link.download = filename;

        document.body.appendChild(link);

        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

        toast.success(
            `${filename} downloaded successfully!`
        );

    } catch (error) {

        console.error(
            "Model download error:",
            error
        );

        toast.error(
            "Failed to download model."
        );
    }
};
const handleDeleteModel = async (filename) => {

    try {

        const confirmed = window.confirm(
            `Are you sure you want to delete ${filename}?`
        );

        if (!confirmed) {
            return;
        }

        await deleteModel(filename, token);

        toast.success("Model deleted successfully!");

        // Refresh model list
        fetchModels();

    } catch (error) {

        console.error(
            "Model delete error:",
            error
        );

        toast.error(
            "Failed to delete model."
        );
    }
};

    useEffect(() => {
        const loadChannels = async () => {
            try {
                const response = await fetchChannels(token);
                const channelsData = response.data?.channels || response.data || [];
                console.log("Fetched channels:", channelsData);
                if (!Array.isArray(channelsData)) throw new Error("Channels is not an array");
                setChannels(channelsData);
            } catch (err) {
                console.error("Error fetching channels:", err.message);
                toast.error("Failed to fetch channels.");
            }
        };
        if (token) loadChannels();
    }, [token]);               

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            toast.warn("Please select a file.");
            return;
        }

        try {
            await uploadFile(file, token);
            toast.success("File uploaded successfully!");
            setFile(null);
            document.getElementById("file-input").value = "";
            fetchFiles();
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "File upload failed!";
            toast.error(errorMessage);
            console.error("Upload error:", errorMessage);
        }
    };

    const handleDelete = async (filename) => {
        try {
            await deleteFile(filename, token);
            toast.success("File deleted successfully!");
            fetchFiles();
        } catch (error) {
            toast.error("Error deleting file.");
        }
    };
    
    const handleRenameClick = (filename) => {
        setSelectedFile(filename);
        setNewFileName(filename);
        setRenameDialogOpen(true);
    };

    const handleRenameConfirm = async () => {
        if (!newFileName.trim() || newFileName === selectedFile) {
            toast.warn("Please enter a new filename.");
            return;
        }
        try {
            await renameFile(selectedFile, newFileName, token);
            toast.success("File renamed successfully!");
            setRenameDialogOpen(false);
            fetchFiles();
        } catch (error) {
            toast.error("Error renaming file.");
        }
    };

    const handleFetchCSV = async () => {
        if (!selectedChannel) {
            toast.warn("Please select a channel first.");
            return;
        }
        try {
             // Get channel name
        //const channelResponse = await getChannelName(selectedChannel, token);
        //setChannelName(channelResponse.data.channelName);
        const selectedChannelData = channels.find(
    (channel) => channel._id === selectedChannel
);
const channelName = selectedChannelData?.name;
            const response = await fetchCSV(selectedChannel, channelName, token);
            if (response.data.status === "success") {
                toast.success("CSV file fetched successfully!");
                fetchFiles(); // Refresh file list
            } else {
                toast.warn(response.data.message || "Something went wrong.");
            }
        } catch (error) {
            const backendError =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Failed to fetch CSV.";
        toast.error(backendError);
        }
    };     
    const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!");
};
const startTerminalResize = (e) => {
    e.preventDefault();

    // Get the main container directly
    const container = e.currentTarget.closest(
        '[data-code-playground-container]'
    );

    if (!container) {
        return;
    }

    const handleMouseMove = (event) => {

    const rect = container.getBoundingClientRect();

    const mouseY = event.clientY - rect.top;

    // Calculate terminal height percentage
    let terminalPercent =
        ((rect.bottom - event.clientY) / rect.height) * 100;

    // Minimum terminal height = 15%
    // Maximum terminal height = 70%
    terminalPercent = Math.max(
        15,
        Math.min(70, terminalPercent)
    );

    setTerminalHeight(terminalPercent);
};

    const handleMouseUp = () => {

        document.removeEventListener(
            "mousemove",
            handleMouseMove
        );

        document.removeEventListener(
            "mouseup",
            handleMouseUp
        );

        document.body.style.cursor = "";
        document.body.style.userSelect = "";
    };

    document.addEventListener(
        "mousemove",
        handleMouseMove
    );

    document.addEventListener(
        "mouseup",
        handleMouseUp
    );

    document.body.style.cursor = "row-resize";
    document.body.style.userSelect = "none";
};
    return (
       <Box
    sx={{
        ...styles.container,
        gridTemplateRows: `${100 - terminalHeight}% ${terminalHeight}%`
    }}
    data-code-playground-container
>
            {/* Sidebar - File Explorer */}
            <Box sx={styles.sidebar}>
                <Typography variant="h6" sx={styles.sidebarTitle}>
                    <FolderIcon sx={{ mr: 1 }} />
                    File Explorer
                </Typography>

                {/* Upload Box */}
                <Paper elevation={3} sx={styles.uploadBox}>
                    <input type="file" id="file-input" style={{ display: "none" }} onChange={handleFileChange} />
                    <Button variant="outlined" component="label" fullWidth sx={{ mb: 1 }} htmlFor="file-input">
                        Select File
                        <input type="file" hidden onChange={handleFileChange} />
                    </Button>
                    <Typography sx={{ fontSize: "12px", textAlign: "center", color: "gray" }}>
                        {file ? file.name : "No file selected"}
                    </Typography>
                    <Button variant="contained" color="primary" startIcon={<CloudUploadIcon />} onClick={handleUpload} fullWidth sx={{ mt: 1 }} disabled={!file}>
                        Upload
                    </Button>
                </Paper>

                <Paper elevation={3} sx={styles.uploadBox}>
                    <Typography variant="body2" sx={{ mb: 1 }}>Select Channel</Typography>
                    <Select
                        fullWidth
                        value={selectedChannel}
                        onChange={(e) => setSelectedChannel(e.target.value)}
                        displayEmpty
                        sx={{ mb: 1 }}
                    >
                        <MenuItem value="" disabled>Select a channel</MenuItem>
                        {channels.map((channel) => (
                            <MenuItem key={channel._id} value={channel._id}>
                                {channel.name}
                            </MenuItem>
                        ))}
                    </Select>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleFetchCSV}
                        disabled={!selectedChannel}
                        fullWidth
                    >
                        Fetch CSV
                    </Button>
                </Paper>
                  <Paper elevation={3} sx={styles.uploadBox}>
    <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", mb: 1 }}
    >
        User ID
    </Typography>

    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}
    >
        <Typography
            variant="body2"
            sx={{
                wordBreak: "break-all",
                color: "#555",
                flexGrow: 1,
            }}
        >
            {userId || "Not Available"}
        </Typography>

        <IconButton
            size="small"
            onClick={() => handleCopy(userId)}
            disabled={!userId}
        >
            <ContentCopyIcon fontSize="small" />
        </IconButton>
    </Box>
</Paper>
              <Paper elevation={1} sx={{ p: 1, bgcolor: "#f5f5f5", mb: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            Channel ID
        </Typography>

        <Paper elevation={3} sx={styles.fileList}> 
                    {files.length === 0 ? (
                        <Typography sx={{ textAlign: "center", color: "gray" }}>No channels files fetched available</Typography>
                    ) : (
//                         files.map((file, index) => (
//                             // <Box key={index} sx={styles.fileItem}>
//                             //     {/* <InsertDriveFileIcon sx={{ color: "gray", fontSize: 18, mr: 1 }} /> */}
//                             //     <span style={styles.fileName}>{file}</span>
//                             // </Box>
//                             <Box
//     key={index}
//     sx={{
//         ...styles.fileItem,
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//     }}
// >
//     <span style={styles.fileName}>{file}</span>

//     <IconButton
//         size="small"
//         onClick={() => handleCopy(file)}
//     >
//         <ContentCopyIcon fontSize="small" />
//     </IconButton>
// </Box>
//                         ))
files.map((file, index) => {

    const channelId = file.replace(".csv", "");

    const matchedChannel = channels.find(
        channel => channel._id === channelId
    );

    return (

        <Box
            key={index}
            sx={{
                ...styles.fileItem,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >

            <Box sx={{ flexGrow: 1 }}>

                <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold" }}
                >
                    {matchedChannel?.name || "Unknown Channel"}
                </Typography>

                <Typography
                    variant="caption"
                    color="text.secondary"
                >
                    {channelId}
                </Typography>

            </Box>

            <IconButton
                size="small"
                onClick={() => handleCopy(channelId)}
            >
                <ContentCopyIcon fontSize="small" />
            </IconButton>

        </Box>

    );

})
                    )}
                </Paper>
    </Paper>

    {/* Trained Models */}
<Paper
    elevation={3}
     sx={{
        ...styles.uploadBox,
        marginTop: "8px",
        height: "190px",
        overflowY: "auto",
        overflowX: "hidden",
        flexShrink: 0
    }}
>
    <Typography
        variant="subtitle2"
        sx={{
            fontWeight: "bold",
            mb: 1
        }}
    >
        Trained Models
    </Typography>

    {trainedModels.length === 0 ? (

        <Typography
            variant="body2"
            sx={{
                textAlign: "center",
                color: "gray",
                py: 1
            }}
        >
            No trained models available
        </Typography>

    ) : (

        trainedModels.map((model, index) => (

         <Box
    key={model.filename || index}
    sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "7px 4px",
        minHeight: "38px",
        boxSizing: "border-box",
        borderBottom:
            index !== trainedModels.length - 1
                ? "1px solid #eee"
                : "none",
        gap: "5px"
    }}
>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: 0,
                        flexGrow: 1
                    }}
                >

                    <ModelTrainingIcon
                        sx={{
                            fontSize: 18,
                            mr: 1,
                            color: "primary.main"
                        }}
                    />

                    <Typography
                        variant="body2"
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                        title={model.filename}
                    >
                        {model.filename}
                    </Typography>

                </Box>

                <Box
    sx={{
        display: "flex",
        alignItems: "center",
        gap: "2px"
    }}
>

    {/* Download */}
    <IconButton
        size="small"
        color="primary"
        onClick={() =>
            handleDownloadModel(model.filename)
        }
        title="Download model"
    >
        <DownloadIcon fontSize="small" />
    </IconButton>

    {/* Delete */}
    <IconButton
        size="small"
        color="error"
        onClick={() =>
            handleDeleteModel(model.filename)
        }
        title="Delete model"
    >
        <DeleteIcon fontSize="small" />
    </IconButton>

</Box>

            </Box>

        ))

    )}
</Paper>
                {/* File List */}
                <Typography variant="h6" sx={styles.sidebarTitle}>
                    <FolderIcon sx={{ mr: 1 }} />
                    File Manager
                </Typography>
                <Paper elevation={3} sx={styles.fileList}> 
                    {files.length === 0 ? (
                        <Typography sx={{ textAlign: "center", color: "gray" }}>No files available</Typography>
                    ) : (
                        files.map((file, index) => (
                            <Box key={index} sx={styles.fileItem}>
                                <InsertDriveFileIcon sx={{ color: "gray", fontSize: 18, mr: 1 }} />
                                <span style={styles.fileName}>{file}</span>

                                <IconButton size="small" color="primary" onClick={() => handleRenameClick(file)}>
                                    <EditIcon />
                                </IconButton>

                                <IconButton size="small" color="error" onClick={() => handleDelete(file)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        ))
                    )}
                </Paper>
                
                {plots.length > 0 && !output.startsWith("Error") && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setPlotPopupOpen(true)}
                        sx={styles.viewPlotButton}
                    >
                        View Plot
                    </Button>
                )}
            </Box>

            {/* Rename Dialog */}
            <Dialog open={renameDialogOpen} onClose={() => setRenameDialogOpen(false)}>
                <DialogTitle>Rename File</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="New Filename" value={newFileName} onChange={(e) => setNewFileName(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRenameDialogOpen(false)} color="secondary">Cancel</Button>
                    <Button onClick={handleRenameConfirm} color="primary">Rename</Button>
                </DialogActions>
            </Dialog>

            {/* Code Editor */}
            <Box sx={styles.editorContainer}>
                <Box sx={styles.topBar}>
                    {/* <Button variant="contained" color="success" startIcon={<PlayArrowIcon />} onClick={handleRunCode} disabled={isRunning}>
                        {isRunning ? "Executing..." : "Run Code"}
                    </Button> */}

                    <TextField
    size="small"
    label="Model Name"
    placeholder="Example: RandomForest"
    value={modelName}
    onChange={(e) => setModelName(e.target.value)}
    sx={{
        width: "220px",
        mr: 1
    }}
/>
                    <IconButton
    color="success"
    onClick={handleRunCode}
    disabled={isRunning}
    title={isRunning ? "Executing..." : "Run Code"}
>
    <PlayArrowIcon />
</IconButton>
                     {/* <Button
        variant="contained"
        color="primary"
        onClick={handleTrainModel}
        disabled={isRunning || isTraining}
    >
        {isTraining
            ? "Training..."
            : "Train & Save Model"
        }
    </Button> */}

    <IconButton
    color="primary"
    onClick={handleTrainModel}
    disabled={isRunning || isTraining}
    title={isTraining ? "Training..." : "Train & Save Model"}
>
    <ModelTrainingIcon />
</IconButton>
     
{/* {trainedModel && (
    <IconButton
        color="secondary"
        onClick={handleDownloadModel}
        title="Download Model"
    >
        <DownloadIcon />
    </IconButton>
)} */}
 {/* {trainedModel && (
        <Button
            variant="contained"
            color="secondary"
            onClick={handleDownloadModel}
        >
            Download Model
        </Button>
    )} */}
                </Box>
                <CodeMirror
                    value={code}
                    height="100%"
                    extensions={[python()]}
                    theme={vscodeDark}
                    onChange={(value) => setCode(value)}
                    style={{ flexGrow: 1, borderRadius: "5px", overflow: "hidden" }}
                />
               
            </Box>

            {/* Output Terminal */}
            <Box sx={styles.terminal}>
    <Box
    onMouseDown={startTerminalResize}
    sx={{
        height: "6px",
        cursor: "row-resize",
        backgroundColor: "#d0d0d0",
        flexShrink: 0,

        "&:hover": {
            backgroundColor: "#1976d2"
        }
    }}
/>
                <Typography variant="h6">Output</Typography>                
                <Paper elevation={3} sx={styles.outputBox}>
                    <pre style={styles.outputText}>{output || "No output yet..."}</pre>
                </Paper>

                {output.length > 200 && (
                    <Button variant="outlined" color="primary" onClick={() => setPopupOpen(true)} sx={styles.viewFullOutput}>
                        View Full Output
                    </Button>
                )}
            </Box>

            {/* Popup for Large Output */}
            <Dialog open={isPopupOpen} onClose={() => setPopupOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Full Output</DialogTitle>
                <DialogContent>
                    <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{output}</pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPopupOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Popup for Plots */}
            {plots.length > 0 && (
                <Dialog open={plotPopupOpen} onClose={() => setPlotPopupOpen(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Plot Output</DialogTitle>
                    <DialogContent>
                        {plots.map((plot, index) => (
                            <img 
                                key={index} 
                                src={`data:image/png;base64,${plot.image}`} 
                                alt={`Plot ${index + 1}`} 
                                style={{ width: "100%", borderRadius: "5px", marginBottom: "10px" }} 
                            />
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setPlotPopupOpen(false)} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            )}

        </Box>
    );
};

// Styles
const styles = {
    // container: {
    //     display: "grid",
    //     // gridTemplateColumns: "260px 4fr",
    //     gridTemplateColumns: "300px 1fr",
    //     gridTemplateRows: "60% 40%",
    //     gridTemplateAreas: `
    //         "sidebar editor"
    //         "sidebar terminal"
    //     `,
    //     // height: "89vh",
    //     height: "calc(100vh - 70px)",
    //     backgroundColor: "#f5f5f5",
    // },
    
   container: {
    display: "grid",
    gridTemplateColumns: "300px 1fr",
    gridTemplateRows: "60% 40%",
    gridTemplateAreas: `
        "sidebar editor"
        "sidebar terminal"
    `,
    height: "calc(100vh - 70px)",
    minHeight: 0,
    overflow: "hidden",
    backgroundColor: "#f5f5f5",
},
   
    // sidebar: {
    //     gridArea: "sidebar",
    //     display: "flex",
    //     flexDirection: "column",
    //     padding: "10px",
    //     backgroundColor: "#ffffff",
    //     borderRight: "1px solid #ddd",
    //     // height: "100%",
    //     // overflowY: "auto",
    //      height: "100%",
    // overflowY: "auto",
    // overflowX: "hidden",

    // scrollbarWidth: "thin",
    // },
  sidebar: {
    gridArea: "sidebar",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    backgroundColor: "#ffffff",
    borderRight: "1px solid #ddd",
    height: "100%",
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "thin",
},
    sidebarTitle: {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
    },
    uploadBox: {
        padding: "10px",
        borderRadius: "5px",
        marginBottom: "8px",
        width: "95%",
        alignSelf: "center",
        backgroundColor: "#f9f9f9",
    },
    // fileList: {
    //     padding: "10px",
    //     borderRadius: "5px",
    //     flexGrow: 1,
    //     backgroundColor: "#fafafa",
    //     maxHeight: "200px",
    //     overflowY: "auto",
    // },
    fileList: {
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#fafafa",
},
    fileItem: {
        display: "flex",
        alignItems: "center",
        padding: "5px",
        fontSize: "14px",
        gap: "8px",
        borderBottom: "1px solid #eee",
    },
    fileName: {
        flexGrow: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    // terminal: {
    //     gridArea: "terminal",
    //     padding: "10px",
    //     backgroundColor: "#ffffff",
    //     display: "flex",
    //     flexDirection: "column",
    //     justifyContent: "flex-start",
    //     alignItems: "stretch",
    //     // marginTop: "30px",
    // },
   terminal: {
    gridArea: "terminal",
    padding: "0px 10px 10px 10px",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
},
    // outputBox: {
    //     padding: "10px",
    //     borderRadius: "5px",
    //     minHeight: "160px",
    //     maxHeight: "300px",
    //     overflowY: "auto",
    //     whiteSpace: "pre-wrap",
    //     backgroundColor: "#333",
    //     color: "#fff",
    //     fontSize: "14px",
    //     fontFamily: "monospace",
    // },
    outputBox: {
    padding: "10px",
    borderRadius: "5px",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    whiteSpace: "pre-wrap",
    backgroundColor: "#333",
    color: "#fff",
    fontSize: "14px",
    fontFamily: "monospace",
},
    outputText: {
        margin: "0",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
    },
    viewFullOutput: {
        marginTop: "10px",
        alignSelf: "center",
    },
    viewPlotButton: {
        marginTop: "15px",
        marginBottom: "10px",
        alignSelf: "center",
        width: "90%",
    },
    editorContainer: {
    gridArea: "editor",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
},
topBar: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px",
    flexShrink: 0,
},
};

export default CodePlayground;
